module.exports = __webpack_public_path__ + "static/img/c2g.744f07dd.webp";